export default __webpack_public_path__ + "static/media/close.e18f2887.svg";